class InterventionRoutes {
    static GetInterventionsPreventives = (): string => {
        return '/interventions-preventives';
    };
    static GetInterventionsNonPreventives = (): string => {
        return '/interventions/phase';
    };
    static GetInterventionPreventive = (id: number): string => {
        return `/interventions-preventives/${id}`;
    };
    static GetInterventionPeriod = (dateDebut: string, dateFin: string): string => {
        return `/interventions-preventives/etats-stats?dateDebut=${dateDebut}&dateFin=${dateFin}`;
    };
    static GetInterventionPeriodMonth = (dateDebut: string, dateFin: string): string => {
        return `/interventions-preventives/etats-stats-mensuelles?dateDebut=${dateDebut}&dateFin=${dateFin}`;
    };
    static GetInterventionSinceMonth = (nbMois: string): string => {
        return `/interventions-non-preventives/etats-stats?nbDerniersMois=${nbMois}`;
    };
    static PostAskIntervention = (): string => {
        return '/demandes-interventions';
    };
    static GetInterventions = (): string => {
        return '/interventions';
    };
    static GetOneInterventions = (id: number): string => {
        return `/interventions/${id}`;
    };
    static GetListDemandeInterventionByNonPreventiveInterventionId = (id: number): string => {
        return `/interventions/${id}/demandes-interventions`;
    };
    static GetNonPreventiveInterventionList = (): string => {
        return '/interventions-non-preventives';
    };
    static GetRapportInfo = (id: number): string => {
        return `/rapports-a-signer/${id}`;
    };
    static GetRapportPDF = (): string => {
        return '/rapports-a-signer/pdf';
    };
    static GetExportXlsRapport = (): string => {
        return '/rapports-a-signer/xls';
    };
    static GetExportXlsInterventions = (): string => {
        return '/interventions-non-preventives/xls';
    };
    static GetRapportsASigner = (): string => {
        return '/rapports-a-signer';
    };
    static SignerRapports = (): string => {
        return '/rapports-a-signer/signer';
    };
    static GetNonPreventiveInterventionStatsByPhase = (id: number, nbMois: string): string => {
        return `/interventions-non-preventives/etats-stats/phases/${id}?nbDerniersMois=${nbMois}`;
    };
    static GetPreventiveInterventionStatsByPhase = (id: number, dateDebut: string, dateFin: string): string => {
        return `/interventions-preventives/etats-stats/phases/${id}?dateDebut=${dateDebut}&dateFin=${dateFin}`;
    };
    static GetPreventiveInterventionStatsMonthByPhase = (id: number, dateDebut: string, dateFin: string): string => {
        return `/interventions-preventives/etats-stats-mensuelles/phases/${id}?dateDebut=${dateDebut}&dateFin=${dateFin}`;
    };
}

class EstimateRoutes {
    static GetEstimate = (): string => {
        return '/devis/etats-stats';
    };
    static PostRefuseEstimate = (): string => {
        return '/devis/refuser';
    };
    static PostCommanderEstimate = (): string => {
        return '/devis/commander-pj';
    };
    static PostSignEstimate = (): string => {
        return '/devis/signer';
    };
    static DeleteSignature = (chiffrageId: number): string => {
        return `/devis/${chiffrageId}/signature`;
    };
    static GetListDevis = (): string => {
        return '/devis';
    };
    static GetDevis = (id: number): string => {
        return `/devis/${id}`;
    };
    static GetDevisPDF = (numero: number, version: number): string => {
        return `/devis/pdf?numero=${numero}&version=${version}`;
    };
    static GetExportXlsDevis = (): string => {
        return '/devis/xls';
    };
    static GetDevisStatsByPhase = (phasesIds: number): string => {
        return `/devis/etats-stats?phasesIds=${phasesIds}`;
    };
}

class DemandeDevisRoutes {
    static GetExportXlsDemandeDevis = (): string => {
        return '/demandes-devis/xls';
    };
    static GetPieceJointeById = (id: number): string => {
        return `/demandes-devis/piece-jointe/${id}`;
    };
    static GetListDemandeDevis = (): string => {
        return '/demandes-devis';
    };
    static PostAskEstimate = (): string => {
        return '/demandes-devis';
    };
    static GetDemandeDevis = (id: number): string => {
        return `/demandes-devis/${id}`;
    };
    static PutDemandeDevis = (id: number): string => {
        return `/demandes-devis/${id}`;
    };
    static DeleteDemandeDevis = (id: number): string => {
        return `/demandes-devis/${id}`;
    };
}

class DemandeInterventionRoutes {
    static GetRequestIntervention = (nbMois: string): string => {
        return `/demandes-interventions/etats-stats?nbDerniersMois=${nbMois}`;
    };
    static GetDemandesIntervention = (): string => {
        return '/demandes-interventions';
    };
    static GetDemandeIntervention = (id: number): string => {
        return `/demandes-interventions/${id}`;
    };
    static GetInterventionsByDemandeInterventionId = (id: number): string => {
        return `demandes-interventions/${id}/interventions`;
    };
    static GetPieceJointeById = (id: number): string => {
        return `/demandes-interventions/piece-jointe/${id}`;
    };
    static GetExportXlsDemandesIntervention = (): string => {
        return '/demandes-interventions/xls';
    };
    static GetRapportsDemandeIntervention = (): string => {
        return '/demandes-interventions/rapports';
    };
    static SendAskInterventionReminder = (id: number): string => {
        return `/demandes-interventions/${id}/relance`;
    };
    static SupprimerDemandesIntervention = (id: number): string => {
        return `/demandes-interventions/${id}`;
    };
    static GetDemandesInterventionStatsByPhase = (id: number, nbMois: string): string => {
        return `/demandes-interventions/etats-stats/phase/${id}?nbDerniersMois=${nbMois}`;
    };
}

class LoginRoutes {
    static PostAuthentication = (): string => {
        return '/auth';
    };
    static VerifierLogin = (): string => {
        return '/auth/verifier-login';
    };
    static RegisterMail = (mail: string): string => {
        return `/auth/register-mail/${mail}`;
    };

    static CreerCompte = (): string => {
        return '/demandes-comptes';
    };
    static CreerCompteFournisseur = (): string => {
        return '/demandes-comptes-fournisseur';
    };
}

class SiteListRoutes {
    static GetList = (): string => {
        return '/adresses-sites';
    };
    static GetGroupeBySite = (): string => {
        return '/adresses-sites/groupes';
    };
    static GetSousGroupeBySite = (): string => {
        return '/adresses-sites/sous-groupes';
    };
}

class BillingRoutes {
    static GetBilling = (): string => {
        return '/factures/etats-stats';
    };
    static GetFacturesEnRetard = (): string => {
        return '/factures/en-retard';
    };
    static GetFacturesAvantEcheance = (): string => {
        return '/factures/avant-echeance';
    };
    static GetFacturePdf = (numeroFacture: string, societeId: number): string => {
        return `/factures/pdf?numeroFacture=${numeroFacture}&societeId=${societeId}`;
    };
    static GetFactures = (): string => {
        return '/factures';
    };
    static GetFacturesXls = (): string => {
        return '/factures/xls';
    };
    static GetFacturesPayees = (): string => {
        return '/factures/payees';
    };
    static GetFacturePdfByInterventionId = (interventionId: number, chantierId: number): string => {
        return `/factures/pdf/${interventionId}?chantierId=${chantierId}`;
    };
}

class TypeRoutes {
    static GetTypes = (chantierId: number): string => {
        return `/chantiers/${chantierId}/types-intervention`;
    };
}

class EquipementRoutes {
    static GetEquipement = (adresseSiteId: number): string => {
        return `adresses-sites/${adresseSiteId}/equipements`;
    };

    static GetEquipementByPhase = (phaseId: number): string => {
        return `phases/${phaseId}/equipement`;
    };

    static GetEquipementBySites = (): string => {
        return 'adresses-sites/equipements';
    };

    static GetEtatEquipement = (): string => {
        return 'etats-fonctionnement-equipement';
    };

    static GetEquipementInterventions = (phaseId: number): string => {
        return `equipements/${phaseId}/demandes-interventions-en-cours`;
    };

    static GetCaracteristiquesEquipement = (phaseId: number): string => {
        return `phases/${phaseId}/caracteristiques`;
    };

    static GetOperationMaintenance = (phaseId: number): string => {
        return `phases/${phaseId}/operations-maintenance`;
    };
}

class ReclamationRoutes {
    static SendReclamation = (): string => {
        return 'reclamations';
    };
    static CloturerReclamation = (reclamationId: number): string => {
        return `reclamations/${reclamationId}/cloturer`;
    };
    static GetReclamations = (): string => {
        return '/reclamations';
    };

    static GetHistoriqueReclamation = (reclamationId: number): string => {
        return `reclamations/${reclamationId}/historique`;
    };

    static GetExportXlsReclamations = (): string => {
        return '/reclamations/xls';
    };

    static GetNbNouvellesReclamations = (): string => {
        return '/reclamations/nbNouvelles';
    };

    static SetReclamationsConsultees = (): string => {
        return '/reclamations/consultees';
    };

    static SendNoteReclamation = (reclamationId: number, note: number): string => {
        return `/reclamations/${reclamationId}/note/${note}`;
    };
}

class PreventifRoutes {
    static GetListPreventif = (): string => {
        return 'planning-preventif';
    };

    static GetInterventionsPreventivesXls = (): string => {
        return 'interventions-preventives/xls';
    };
}

class AccountRoutes {
    static GetSocieteIds = (): string => {
        return '/profil/societes';
    };

    static GetInformations = (): string => {
        return '/profil/informations';
    };

    static PutTelephonePortable = (): string => {
        return '/profil/informations/telephone-portable';
    };

    static PutTelephoneFixe = (): string => {
        return '/profil/informations/telephone-fixe';
    };

    static PutMdp = (): string => {
        return '/profil/informations/mdp';
    };

    static PostDemandeSuppressionCompte = (): string => {
        return '/profil/suppression-compte';
    };
}

class ProjetRoutes {
    static GetProjets = (): string => {
        return '/chantiers';
    };
    static GetStatutBim = (): string => {
        return '/chantiers/bim-statut';
    };
}

class ContactRoutes {
    static GetInterlocuteurs = (adresseSiteId: number): string => {
        return `/adresses-sites/${adresseSiteId}/interlocuteurs`;
    };

    static SendMessage = (): string => {
        return '/contact';
    };

    static GetExportXlsAllContacts = (): string => {
        return '/contacts/xls';
    };

    static GetExportXlsContacts = (siteId: number): string => {
        return `/contacts/xls?siteId=${siteId}`;
    };

    static GetExportXlsFilteredContacts = (): string => {
        return '/contacts/xls';
    };
}

class CommunicationRoutes {
    static GetCommunication = (): string => {
        return '/communications';
    };

    static SetCommunicationVue = (idCommunication: string): string => {
        return `/communications/${idCommunication}/vue`;
    };

    static SetCommunicationEtreContacte = (idCommunication: string): string => {
        return `/communications/${idCommunication}/etre-contacte`;
    };

    static SetCommunicationEnSavoirPlus = (idCommunication: string): string => {
        return `/communications/${idCommunication}/savoir-plus`;
    };

    static SetCommunicationNePlusAfficher = (idCommunication: string): string => {
        return `/communications/${idCommunication}/ne-plus-afficher`;
    };
}

class DocumentReglementaire {
    static GetDocumentReglementaire = (): string => {
        return '/document-reglementaire';
    };
    static GetDocumentReglementairePDF = (): string => {
        return '/document-reglementaire/pdf';
    };
    static GetAllDocumentReglementairePDF = (): string => {
        return '/document-reglementaire/pdf/all';
    };
    static GetTypesDocumentReglementaire = (): string => {
        return '/document-reglementaires/types';
    };
    static GetAdrPDF = (): string => {
        return '/analyses-de-risques/pdf';
    };
    static GetAllAdrPDF = (): string => {
        return '/analyses-de-risques/pdf/all';
    };
}

class SuiviDIRoutes {
    static GetSuiviDI = (): string => {
        return '/suivi-di';
    };

    static ActivationSuiviDI = (): string => {
        return '/suivi-di/activation';
    };

    static ActivationEmailSuiviDI = (emailId: number): string => {
        return `/suivi-di/emails-suivi/${emailId}/activation`;
    };

    static SuppressionEmailSuiviDI = (emailId: number): string => {
        return `/suivi-di/emails-suivi/${emailId}`;
    };

    static AjouterEmailSuiviDI = (): string => {
        return '/suivi-di/emails-suivi';
    };
}

class PreavisInterventionRoutes {
    static GetPreavisInterventions = (): string => {
        return '/preavis-interventions';
    };

    static CreatePreavisIntervention = (): string => {
        return '/preavis-interventions';
    };

    static DeletePreavisIntervention = (preavisId: number): string => {
        return `/preavis-interventions/${preavisId}`;
    };

    static UpdatePreavisIntervention = (preavisId: number): string => {
        return `/preavis-interventions/${preavisId}`;
    };

    static UpdateActivationPreavisIntervention = (preavisId: number): string => {
        return `/preavis-interventions/${preavisId}/activation`;
    };
}

class NFC {
    static GetNFCTags = (): string => {
        return '/nfc-tags';
    };
    static GetHistoriqueNFC = (numeroNFC: string): string => {
        return `/nfc-tag/${numeroNFC}/historique`;
    };
    static GetExportXlsNFC = (): string => {
        return '/nfc-tag/xls';
    };
}

class ActualitesRoutes {
    static GetActualites = (): string => {
        return '/actualites';
    };

    static SetActualiteConsulte = (actualiteId: number): string => {
        return `/actualite/${actualiteId}`;
    };
}
class TypesInterventionRoutes {
    static GetTypesInterventions = (): string => {
        return '/types-intervention';
    };
}

class RapportRoutes {
    static GetRapport = (): string => {
        return '/rapports';
    };
    static GetRapportPDF = (): string => {
        return '/rapports/pdf';
    };
    static GetAllRapportPDF = (): string => {
        return '/rapports/pdf/all';
    };
}

class CompteurRoutes {
    static SendCounterForm = (): string => {
        return '/compteur';
    };
}

class SatisfactionRoutes {
    static RecupererDerniereSatisfaction = (): string => {
        return '/satisfactions/derniere';
    };
    static GetQuestions = (): string => {
        return '/satisfactions/questions';
    };

    static SubmitResponses = (): string => {
        return '/satisfactions';
    };

    static RepondrePlusTardClickCount = (): string => {
        return '/satisfactions/repondre-plus-tard';
    };

    static GetClickCount = (): string => {
        return '/satisfactions/click-count';
    };

    static ModalGestionOptions = (): string => {
        return '/satisfactions/modal-gestion-options';
    };

    static UpdateSatisfaction = (): string => {
        return '/satisfactions';
    };
}

class DoeRoutes {
    static RecupererDoePublies = (): string => {
        return '/doe/publies';
    };
    static RecupererPdfDoe = (id: number): string => {
        return `/doe/${id}/pdf`;
    };
}

class AnalyseDeRisqueRoutes {
    static RecupererAnalyseDeRisquePublies = (): string => {
        return '/analyses-de-risques';
    };
    static RecupererPdfAnalyseDeRisque = (id: number): string => {
        return `/analyse-de-risque/${id}/pdf`;
    };
}

class PriseEnChargeRoutes {
    static RecupererPrisesEnCharge = (): string => {
        return '/prises-en-charge';
    };
    static RecupererPdfPriseEnCharge = (idDocExterne: string | number, idVersionExterne: string | number): string => {
        return `/prises-en-charge/${idDocExterne}/${idVersionExterne}/pdf`;
    };
}

class FactureFournisseurRoutes {
    static RecupererStatsFacturesFournisseur = (): string => {
        return '/factures-fournisseurs/etats-stats';
    };
    static RecupererFacturesFournisseur = (): string => {
        return '/factures-fournisseurs';
    };
    static RecupererFactureFournisseur = (id: number): string => {
        return `/factures-fournisseurs/${id}`;
    };
    static RecupererFactureFournisseurRejetee = (id: string): string => {
        return `/factures-fournisseurs-rejetees/${id}`;
    };
    static Contacter = (factureId: string): string => {
        return `/factures-fournisseurs/${factureId}/contacter`;
    };
    static ContacterComptaFournisseur = (factureId: string): string => {
        return `/factures-fournisseurs/${factureId}/contacter-comptabilite`;
    };
    static RecupererReglementsFournisseur = (): string => {
        return '/factures-fournisseurs/reglements';
    };
    static RecupererReglementFournisseur = (id: number): string => {
        return `/factures-fournisseurs/reglements/${id}`;
    };
    static RecupererFacturesFournisseurXls = (): string => {
        return '/factures-fournisseurs/xls';
    };
    static RecupererReglementsFournisseurXls = (): string => {
        return '/factures-fournisseurs/reglements/xls';
    };
}

class LangueRoutes {
    static RecupererLanguesDisponibles = (): string => {
        return '/langues';
    };
    static RecupererLangueSelectionnee = (): string => {
        return '/langues/compte';
    };
    static EnregistrerLangue = (langueId: number): string => {
        return `/langues/${langueId}`;
    };
}

class TraductionRoutes {
    static RecupererTraductions = (): string => {
        return '/traductions';
    };
}

class DashboardRoutes {
    static GetDashboard = (): string => {
        return '/dashboards';
    };
    static GetDashboardById = (id: number): string => {
        return `/dashboards/${id}`;
    };
    static DeleteDashboard = (id: number | undefined): string => {
        return `/dashboards/${id}`;
    };
}

class WidgetsRoutes {
    static GetWidgets = (): string => {
        return '/widgets';
    };

    static DeleteWidgets = (id: number): string => {
        return `/widgets/${id}`;
    };
    static ChangeWidgetPosition = (position: number): string => {
        return `/widgets/change-position/${position}`;
    };
}

class linksRoutes {
    static GetSharepointLink = (): string => {
        return '/liensExternes/sharepoint';
    };
}

class DevisValidationRoutes {
    static GetDetails = (token: string): string => {
        return `/devis-validation/details?token=${encodeURIComponent(token)}`;
    };
    static PostConfirmer = (token: string): string => {
        return `/devis-validation/confirmer?token=${encodeURIComponent(token)}`;
    };
    static GetPdf = (token: string): string => {
        return `/devis-validation/pdf?token=${encodeURIComponent(token)}`;
    };
}

class AppInfoRoutes {
    static GetAppInfo = (): string => {
        return '/app-info';
    };
}

export const Routes = {
    InterventionRoutes,
    EstimateRoutes,
    DemandeDevisRoutes,
    DemandeInterventionRoutes,
    LoginRoutes,
    BillingRoutes,
    SiteListRoutes,
    TypeRoutes,
    EquipementRoutes,
    ReclamationRoutes,
    PreventifRoutes,
    AccountRoutes,
    ContactRoutes,
    CommunicationRoutes,
    DocumentReglementaire,
    SuiviDIRoutes,
    NFC,
    ActualitesRoutes,
    TypesInterventionRoutes,
    RapportRoutes,
    CompteurRoutes,
    SatisfactionRoutes,
    FactureFournisseurRoutes,
    DashboardRoutes,
    WidgetsRoutes,
    DoeRoutes,
    ProjetRoutes,
    LangueRoutes,
    TraductionRoutes,
    AnalyseDeRisqueRoutes,
    PriseEnChargeRoutes,
    linksRoutes,
    PreavisInterventionRoutes,
    DevisValidationRoutes,
    AppInfoRoutes,
};
